class PreorderOpener extends HTMLElement {
    constructor() {
        super();
        this.btn = this.querySelector(".open-modal");
        this.modal = document.querySelector(".preorder-modal");
        this.btn?.addEventListener("click", (e) => {
            e.preventDefault();
            const button = e.currentTarget;
            $(this.modal).modal("show");
            const form = document.getElementById("form-preorder");
            const submitButton = form.querySelector('button[type="submit"]');
            const successMessage = form.querySelector("#successMessage");
            successMessage.style.display = "none";
            submitButton.style.display = "block";
            const productHandle = button.getAttribute("data-product-handle");
            const inputProductId =
                this.modal.querySelector("#input-product-id");
            inputProductId.value = productHandle;
            getProductVariantDetails(productHandle)
                .then((data) => {
                    const productTitle = data.productTitle;
                    this.modal.querySelector(".modal-title").textContent =
                        productTitle;
                    const select = this.modal.querySelector("#variants");
                    select.options.length = 0;

                    const variants = data.variants;
                    variants.forEach((variant) => {
                        const optionElement = document.createElement("option");
                        optionElement.value = variant.id;
                        optionElement.textContent = variant.title;
                        select.add(optionElement);
                    });
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        });
    }
}

customElements.define("preorder-opener", PreorderOpener);

async function getProductDetails(productId) {
    try {
        const response = await fetch(`/products/${productId}.json`);
        const data = await response.json();
        return data.product;
    } catch (error) {
        console.error("Error to get product details:", error);
        return null;
    }
}

async function getProductVariantDetails(productId) {
    try {
        const product = await getProductDetails(productId);
        if (product) {
            const variants = product.variants;
            return {
                productTitle: product.title,
                variants: variants.map((variant) => ({
                    title: variant.title,
                    id: variant.id,
                })),
            };
        }
        return [];
    } catch (error) {
        console.error("Error to get product variants:", error);
        return [];
    }
}

const form = document.getElementById("form-preorder");
const submitButton = form.querySelector('button[type="submit"]');

submitButton.addEventListener("click", async (event) => {
    event.preventDefault();
    const API_PUBLIC_KEY = "QWMerD";
    const NEWSLETTER_LIST_ID = "WbYSm2";
    const variantId = form.querySelector("#variants").value;
    const email = form.querySelector("#email").value;
    const subscribeToNewsLetter = form.querySelector(
        "#subscribe_for_newsletter:checked"
    )
        ? true
        : false;

    const payload = {
        data: {
            type: "back-in-stock-subscription",
            attributes: {
                profile: {
                    data: {
                        type: "profile",
                        attributes: {
                            email: email,
                        },
                    },
                },
                channels: ["EMAIL"],
            },
            relationships: {
                variant: {
                    data: {
                        type: "catalog-variant",
                        id: `$shopify:::$default:::${variantId}`,
                    },
                },
            },
        },
    };

    const requestOptions = {
        method: "POST",
        headers: {
            accept: "application/json",
            revision: "2024-07-15",
            "content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify(payload),
    };
    const backInStockSubscription = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${API_PUBLIC_KEY}`,
        requestOptions
    )
        .then((result) => result)
        .catch((error) => error);
    if (backInStockSubscription.ok) {
        successMessage = form.querySelector("#successMessage");
        successMessage.innerHTML =
            "You're in! We'll let you know when it's available. <a data-dismiss='modal' href='#'>Close</a>";
        successMessage.style.display = "block";
        submitButton.style.display = "none";
    }
    if (subscribeToNewsLetter) {
        const formData = {
            data: {
                type: "subscription",
                attributes: {
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: email,
                            },
                        },
                    },
                },
                relationships: {
                    list: {
                        data: {
                            type: "list",
                            id: NEWSLETTER_LIST_ID,
                        },
                    },
                },
            },
        };

        await fetch(
            `https://a.klaviyo.com/client/subscriptions/?company_id=${API_PUBLIC_KEY}`,
            {
                method: "POST",
                headers: {
                    revision: "2024-07-15",
                    "content-type": "application/json",
                },
                body: JSON.stringify(formData),
            }
        ).then((response) => response);
    }
});

document.querySelector("body").addEventListener("click", (e) => {
    const target = e.target;
    const modalTarget = document.querySelector(".preorder-modal");
    const overlayContainer = document.querySelector(".modal-backdrop");
    if (!modalTarget || !overlayContainer) return;
    if (target === overlayContainer) {
        document.querySelector(".close").click();
    }
});
